// src/utils/staffEntry.js — wspólna logika statusu TBC / tentative (?)

const TENTATIVE_SUFFIX_RE = /\s+\(\?\)\s*$/;

export function isStaffTentative(entry) {
    if (!entry) return false;
    if (typeof entry === 'object') {
        return !!(entry.tentative || entry.unknown || entry.isPlaceholder);
    }
    if (typeof entry === 'string') {
        return TENTATIVE_SUFFIX_RE.test(entry.trim());
    }
    return false;
}

/** Zwraca { name, tentative } — nazwa bez sufiksu „ (?)”. */
export function parseStaffEntry(entry) {
    if (typeof entry === 'string') {
        const raw = entry.trim();
        if (!raw) return null;
        const tentative = isStaffTentative(raw);
        const name = tentative ? raw.replace(TENTATIVE_SUFFIX_RE, '').trim() : raw;
        return name ? { name, tentative } : null;
    }
    if (!entry || typeof entry !== 'object') return null;
    const nameRaw = String(entry.name || entry.label || '').trim();
    if (!nameRaw) return null;
    const tentative = isStaffTentative(entry) || TENTATIVE_SUFFIX_RE.test(nameRaw);
    const name = tentative ? nameRaw.replace(TENTATIVE_SUFFIX_RE, '').trim() : nameRaw;
    return name ? { name, tentative: !!tentative } : null;
}

export function normalizeStaffEntries(staffList) {
    return (staffList || []).map(parseStaffEntry).filter(Boolean);
}

/** Format zapisywany w ev.staff — obiekt z tentative zachowuje TBC. */
export function formatStaffEntryForStore({ name, tentative }) {
    if (!name) return null;
    if (tentative) {
        return { name, tentative: true };
    }
    return { name, tentative: false };
}

export function formatStaffListForStore(entries) {
    return (entries || []).map(formatStaffEntryForStore).filter(Boolean);
}

export function staffDisplayName(entry) {
    const parsed = parseStaffEntry(entry);
    return parsed?.name || '';
}
